// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer__extra-links":"Footer_footer__extra-links__um9Lz"};